<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
export default {
  computed: {
    layout () {
      return this.$route.meta.layout
    }
  }
}
</script>

<style lang="scss">
legend:not(.col-form-label) {
  font-size: 18px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 500;
}
</style>
